module.exports = __webpack_public_path__ + "static/media/consist-logo.774fbdb7.svg";